<template>
	<h1>{{ heading }}</h1>
</template>

<script>
	export default {
		name: 'PageHeading',
		props: {
			heading: {
				type: String
			}
		}
	}
</script>

<style scoped>
h1 {
	border-bottom: 2px solid #ECECEC;
}
</style>